import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { auth as authAPI } from '../services/api';
import '../styles/Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showVerificationWarning, setShowVerificationWarning] = useState(false);
  const [unverifiedEmail, setUnverifiedEmail] = useState('');
  const [resending, setResending] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShowVerificationWarning(false);
    setLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate('/');
    } catch (err) {
      const errorData = err.response?.data;

      // Email verification required
      if (errorData?.requiresVerification) {
        setShowVerificationWarning(true);
        setUnverifiedEmail(errorData.email || formData.email);
        setError(errorData.message);
      } else {
        setError(errorData?.message || 'Hiba történt a bejelentkezés során');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResendEmail = async () => {
    setResending(true);
    setError('');

    try {
      const response = await authAPI.resendVerification(unverifiedEmail);
      setError(''); // Clear error
      setShowVerificationWarning(false); // Hide warning
      alert(response.data.message || 'Megerősítő email újraküldve! Ellenőrizd a postaládádat.');
    } catch (err) {
      setError(err.response?.data?.message || 'Email küldése sikertelen');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card">
          <h2>Bejelentkezés</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email cím</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Jelszó</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength="6"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            {/* Email Verification Warning */}
            {showVerificationWarning && (
              <div className="verification-warning">
                <div className="warning-icon">⚠️</div>
                <p className="warning-text">
                  Az email címed még nincs megerősítve. Ellenőrizd a postaládádat!
                </p>
                <button
                  type="button"
                  className="btn btn-outline btn-small"
                  onClick={handleResendEmail}
                  disabled={resending}
                >
                  {resending ? 'Küldés...' : 'Email Újraküldése'}
                </button>
              </div>
            )}

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Bejelentkezés...' : 'Bejelentkezés'}
            </button>
          </form>

          <p className="auth-link">
            <Link to="/forgot-password">Elfelejtetted a jelszavad?</Link>
          </p>

          <p className="auth-link">
            Még nincs fiókod? <Link to="/register">Regisztrálj itt!</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
